import n, { forwardRef as c } from "react";
import { iconNameToURL as d } from "@nv-brand-assets/icons";
export * from "@nv-brand-assets/icons";
import "external-svg-loader";
const m = "1em", l = "1em", p = "inline-block", s = c(
  ({ iconName: o, lazyLoading: a, size: t, variant: e = "line", ...i }, r) => /* @__PURE__ */ n.createElement(
    "svg",
    {
      "data-src": d(o, e),
      height: t ?? m,
      width: t ?? l,
      display: p,
      "data-icon-name": o,
      key: `${o}:${e}`,
      ...i,
      ...a ? { "data-loading": "lazy" } : {},
      ref: r
    }
  )
);
s.displayName = "NvidiaGUIIcon";
export {
  s as NvidiaGUIIcon
};
